import type { CSSProperties, ReactNode } from "react";
import { pillPath } from "./pill";

/**
 * 大事なところの しるし（参照元：Holoriba-homepage src/components/Highlight.tsx の band と ring）。
 * ロゴの3色で、読んでほしい文と押してほしいボタンを目立たせる。**たくさん使わない**（1画面に1〜2か所）。
 * - band：文字の下半分に3色の帯
 * - ring：ボタンのまわりに3色の輪と紙片
 * 現れる合図は MotionRoot の data-drawn。動きを減らす設定では、はじめから出ている。飾りなので読み上げは中の文字だけ
 */

type Kind = "band" | "ring";

const RING_W = 276;
const RING_H = 64;
const RING_D = pillPath(RING_W, RING_H);

export function Highlight({ kind = "band", delay, children }: { kind?: Kind; delay?: number; children: ReactNode }) {
  const style = delay === undefined ? undefined : ({ "--hl-delay": `${delay}s` } as CSSProperties);
  if (kind === "ring") {
    return (
      <span className="hl hl--ring" data-hl data-loop style={style}>
        {children}
        <svg className="hl__ring" viewBox={`0 0 ${RING_W} ${RING_H}`} preserveAspectRatio="none" aria-hidden="true" focusable="false">
          <path pathLength={1} d={RING_D} />
          <path pathLength={1} d={RING_D} />
          <path pathLength={1} d={RING_D} />
        </svg>
        <span className="hl__bit hl__bit--cyan" aria-hidden="true" />
        <span className="hl__bit hl__bit--petal" aria-hidden="true" />
        <span className="hl__bit hl__bit--lavender" aria-hidden="true" />
      </span>
    );
  }
  return (
    <mark className="hl hl--band" data-hl style={style}>
      {children}
    </mark>
  );
}
